import React from "react";
import { Routes, Route, useNavigate, useLocation, useParams } from "react-router-dom";
import { CategoriesLoadingDialog } from "./categories-loading-dialog/CategoriesLoadingDialog";
import { CategoryDeleteDialog } from "./category-delete-dialog/CategoryDeleteDialog";
import { CategoriesDeleteDialog } from "./categories-delete-dialog/CategoriesDeleteDialog";
import { CategoriesFetchDialog } from "./categories-fetch-dialog/CategoriesFetchDialog";
import { CategoriesUpdateStatusDialog } from "./categories-update-status-dialog/CategoriesUpdateStatusDialog";
import { CategoriesCard } from "./CategoriesCard";
import { CategoriesUIProvider } from "./CategoriesUIContext";

function CategoriesDeleteDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <CategoriesDeleteDialog show={location.pathname === "/category/deleteCategories"} onHide={() => navigate("/category")} />;
}
function CategoryDeleteDialogRoute() {
  const navigate = useNavigate();
  const { id } = useParams();
  return <CategoryDeleteDialog show id={id} onHide={() => navigate("/category")} />;
}
function CategoriesFetchDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <CategoriesFetchDialog show={location.pathname === "/category/fetch"} onHide={() => navigate("/category")} />;
}
function CategoriesUpdateStatusDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <CategoriesUpdateStatusDialog show={location.pathname === "/category/updateStatus"} onHide={() => navigate("/category")} />;
}

export function CategoriesPage() {
  const navigate = useNavigate();
  const categoriesUIEvents = {
    newCategoryButtonClick: () => navigate("/category/new"),
    openEditCategoryPage: (id) => navigate(`/category/${id}/edit`),
    openDeleteCategoryDialog: (id) => navigate(`/category/${id}/delete`),
    openDeleteCategoriesDialog: () => navigate("/category/deleteCategories"),
    openFetchCategoriesDialog: () => navigate("/category/fetch"),
    openUpdateCategoriesStatusDialog: () => navigate("/category/updateStatus"),
  };

  return (
    <CategoriesUIProvider categoriesUIEvents={categoriesUIEvents}>
      <CategoriesLoadingDialog />
      <Routes>
        <Route path="deleteCategories" element={<CategoriesDeleteDialogRoute />} />
        <Route path=":id/delete" element={<CategoryDeleteDialogRoute />} />
        <Route path="fetch" element={<CategoriesFetchDialogRoute />} />
        <Route path="updateStatus" element={<CategoriesUpdateStatusDialogRoute />} />
      </Routes>
      <CategoriesCard />
    </CategoriesUIProvider>
  );
}
